import React from 'react'
import PropTypes from 'prop-types'

import NavHighlighter from 'components/NavHighlighter'

const AddButton = props => (
  <div className="col-md-2">
    <NavHighlighter
      className="btn btn-lg btn-primary pull-right"
      to="/country_taxes/add"
      pathname={props.pathname}
      style={{
        margin: '15px 0 16px',
      }}
      noli
    >
        Add a new country tax &nbsp; &nbsp;<i className="fa fa-plus" />
    </NavHighlighter>
  </div>
)

AddButton.defaultProps = {
  pathname: '',
}

AddButton.propTypes = {
  pathname: PropTypes.string.isRequired,
}

export default AddButton
